// app/javascript/components/shared/ui/Label.js
//
// Small caps mini-label. Used everywhere there's a tiny meta tag above a value
// (date fields, KPI cards, section headers, key/value rows).
import React from "react"
import { cva } from "class-variance-authority"
import clsx from "clsx"

export const labelVariants = cva(
  "font-semibold uppercase tracking-wider whitespace-nowrap m-0",
  {
    variants: {
      tone: {
        muted:   "text-slate-400",
        default: "text-slate-500",
      },
      size: {
        xs: "text-[10px]",
        sm: "text-[10.5px]",
        md: "text-[12px]",
      },
    },
    defaultVariants: { tone: "muted", size: "sm" },
  }
)

const Label = ({ tone, size, className, as: Tag = "label", ...props }) => (
  <Tag className={clsx(labelVariants({ tone, size }), className)} {...props} />
)

export default Label
